import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["cursor-pointer inline-flex items-center px-3 py-1 mr-1 rounded-full text-xs font-medium", _ctx.muted ? 'bg-gray-100 text-gray-600' : 'bg-blue-200 text-sky'])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}